<template>
  <div id="app">
    <router-view/>
    <el-dialog
      title="消息提示"
      :visible.sync="dialogVisible"
      width="30%">
      <div style="text-align: center;color: #dd6161; padding: 5px 20px;">{{ message}}</div>
    </el-dialog>
  </div>

</template>

<script>
import {getCustomToken} from '@/utils/auth'
import { orderPrint } from '@/utils/LodopFuncs'

export default {
  name: 'App',
  data() {
    return {
      adminId: null,
      dialogVisible:false,
      message: null,
      content:'',
      setting: {
        height: 500,
        width:600,
        draggable_modal: true
      },
    }
  },
  created() {
    this.adminId = getCustomToken("adminNum");
    if (this.adminId != null) {
      this.init();
    }
    //let data = '{"key":"print_order","value":{"amount":1.00,"createTime":"2026-01-29 23:48:53","id":2601292348527184,"merchantTitle":"KK优德酒馆","orderPrice":0.01,"orderTotal":0,"orderType":3,"payPrice":0.01,"payTime":"2026-01-29 23:49:00","payType":1,"printType":1,"productList":[{"id":37,"orderId":2601292348527184,"productId":57,"productImage":"https://img.holyiac.com/images/2026-01-25/8ca25a69df9a4d9a9af683b818216962.jpg","productNum":1,"productPrice":0.01,"productTitle":"矿泉水"}],"state":1,"takeMealsCode":"002","tradeNo":"4200003022202601290082395993"}}';
    //let result = JSON.parse(data);
    //orderPrint(result.value);
  },
  methods: {
    save(){
      console.log(this.content)
    },
    init: function () {
      if (typeof (WebSocket) === "undefined") {
        alert("您的浏览器不支持socket")
      } else {
        // 实例化socket
        // this.socket = new WebSocket("wss://api.holyiac.com/socket-service/ws-admin/" +
        this.socket = new WebSocket("wss://api.holyiac.com/socket-service/ws-admin/" +
        // this.socket = new WebSocket(process.env.BASE_WS_API + "/ws-admin/" +
          this.adminId + "-" + parseInt((Math.random() * 9999).toString()))
        // 监听socket连接
        this.socket.onopen = this.open
        // 监听socket错误信息
        this.socket.onerror = this.error
        // 监听socket消息
        this.socket.onmessage = this.getMessage
        this.socket.close = this.close;
        this.socket.send = this.send;
      }
    },
    open: function () {
      if (this.connectId != null) {
        clearInterval(this.connectId);
      }
      this.connectId = setInterval(() => {
        if (this.socket.readyState === WebSocket.OPEN) {
          this.socket.send("ping");
        } else {
          clearInterval(this.connectId);
          this.init();
        }
      }, 10000);
    },
    error: function () {
      this.connectId = setInterval(() => {
        window.location.reload();
      }, 5000);
    },
    //接收服务器发来的消息
    getMessage: function (e) {
      let result = JSON.parse(e.data);
      if (result.key === "balance" || result.key == "order_message"){
        this.message = result.value;
        this.dialogVisible = true;
      }
      if (result.key === "pdfMessage"){
        window.open(result.pdfUrl);
      }
      if(result.key == "print_order"){
        orderPrint(result.value)
      }

    },

    //给服务器发消息的方法
    send: function () {
    },
    //连接关闭
    close: function () {
    },
  }
}
</script>

<style>
body,html,#app{
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
  //min-width: 1920px;
  //min-height: 1080px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue